import { getUrlParam } from '../utils/util';

export default {
    // 用于可能的并行请求纠错
    // 这个和routerBizKey理论上可以互换……刚开始开发的时候没注意就随便用了……
    currentBizKey: null,
    // 其它数据...
    currentBizInfo: null,
    // 路由中的 bizKey，切换路由时会同步
    routerBizKey: null,
    // 路由中的 pageKey
    routerPageKey: null,
    // 通过query传递的透传数据
    collectExtension: null,
    // 全局提交等待状态
    isSubmitting: false,

    // landing页面
    // 当前用户填写的状态（待处理、已处理、已驳回、处理中、已完成）
    status: 0,
    // 当前用户填写的状态文字提示
    remark: '',

    // 表单页面
    bizInfo: {},
    pageInfo: {},
    nextPageKey: '',
    userData: '',
    extraInfo: {},
    // query中的from参数
    from: '',
    originBizKey: '',
    soid: '',
    source: '',
    entranceId: '',
    otherQuery: {},
    // 前端缓存过期时长（毫秒）
    stashEffectiveDuration: 0,
    ticket: {
        code: 0, // 0:不需要创建 1:工单创建成功 2:工单已存在，催单｜重新打开
        soid: '',
    },
    myServiceBizKey: '', // 服务进度免登录
    oid: '',
    orderType: '',
    gameId: '',
    appId: '',
    gameVersion: '',
    useTitle: '',
    fromCard: '', // URL query 中的 fromCard 参数（'true' 时提交接口需携带 fromCard: true）
    checkPhone: '', // 有值需要短信验真，短信验真的未脱敏手机号
    announcementRemark: '', // 有值需要展示公告，值为富文本
    gray: {}, // 信息收集四期的灰度控制
    errorData: '', // 字段级错误信息
    noticeAutoOpen: false, // 是否自动打开公告
    viewType: Number(getUrlParam('viewType')) || 0, // 视图类型
};
